import React from 'react';
import '../assets/css/Onda.css';

function Onda(props) {
	return (
		<section className={props.image}>&nbsp;</section>
	);
}

export default Onda;